/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Misc_CostInputs */

const en_field_misc_cost = /** @type {(inputs: Field_Misc_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other costs`)
};

/**
* | output |
* | --- |
* | "Other costs" |
*
* @param {Field_Misc_CostInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_misc_cost = /** @type {((inputs?: Field_Misc_CostInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Misc_CostInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_misc_cost(inputs)
});